import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.makeReportVolume.success: {
            return action.payload;
        }

        case constants.makeReportVolume.try:
        case constants.makeReportVolume.error: {
            return initialState;
        }

        default:
            return state;
    }
}